var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.92266 1.16699H5.12161C3.0362 1.16699 1.79297 2.41022 1.79297 4.49564V9.29095C1.79297 11.3821 3.0362 12.6253 5.12161 12.6253H9.91693C12.0023 12.6253 13.2456 11.3821 13.2456 9.29668V4.49564C13.2513 2.41022 12.0081 1.16699 9.92266 1.16699Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59502 9.04438C4.4346 9.04438 4.28564 8.95844 4.21116 8.80949C4.10231 8.59751 4.18825 8.33969 4.40595 8.23084C4.90439 7.98449 5.32835 7.60636 5.632 7.14803C5.73512 6.99334 5.73512 6.79855 5.632 6.64386C5.32262 6.18553 4.89866 5.8074 4.40595 5.56105C4.18825 5.45792 4.10231 5.20011 4.21116 4.9824C4.31429 4.77042 4.5721 4.68449 4.78408 4.79334C5.41429 5.10844 5.95283 5.58396 6.34241 6.16834C6.6346 6.60949 6.6346 7.1824 6.34241 7.62355C5.95283 8.20792 5.41429 8.68344 4.78408 8.99855C4.72679 9.02719 4.65804 9.04438 4.59502 9.04438Z",
    fill: "#7C7C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3854 9.04443H8.09375C7.85885 9.04443 7.66406 8.84964 7.66406 8.61475C7.66406 8.37985 7.85885 8.18506 8.09375 8.18506H10.3854C10.6203 8.18506 10.8151 8.37985 10.8151 8.61475C10.8151 8.84964 10.6203 9.04443 10.3854 9.04443Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.387a0c69adcd2869781a0773a6950a55.svg";
export { ForwardRef as ReactComponent };